import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { TableRow, TableRowColumn } from 'material-ui/Table';

import Grid from '../grid/Grid';
import enhancer from '../enhancer';

class Subjects extends React.Component {
  renderRow = ({ node }) => (
    <TableRow key={node.id}>
      <TableRowColumn>{node.name}</TableRowColumn>
      <TableRowColumn>{node.description}</TableRowColumn>
    </TableRow>
  );

  render() {
    const { master } = this.props;

    return (
      <div>
        <Grid
          headers={['Name', 'Description']}
          rows={master.allSubjects.edges}
          renderRow={this.renderRow}
        />
      </div>
    );
  }
}

const query = graphql`
  query SubjectsAdminQuery {
    master {
      ...Subjects_master
    }
  }
`;

export default enhancer(Subjects, {
  relay: {
    query,
    create: () =>
      createFragmentContainer(Subjects, {
        master: graphql`
          fragment Subjects_master on Master {
            allSubjects(first: 10) {
              edges {
                node {
                  id
                  name
                  description
                }
              }
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/components/master/Subjects.js